import { useMemo } from "react";


export default function useIsPortrait() {
    return useMemo(() => window.innerHeight > window.innerWidth, [window]);
}
